import { type ExternalToast, toast } from 'sonner'

/**
 * Avisos de la app (toasts): el ÚNICO sitio que llama a sonner. Pinta `BrutalToaster`.
 *
 * - `success` → **verde**: algo salió bien (incluidos los que ofrecen «Deshacer»).
 * - `error` → **rojo**: algo falló.
 * - `info` → **amarillo**: aviso neutro («pulsa atrás otra vez para salir»).
 *
 * No hay aviso «sin tipo»: con el estilo `unstyled` del toaster cada tipo pinta su color, y un
 * aviso sin tipo salía sin fondo, transparente sobre la cabecera (nov-2026). ESLint prohíbe
 * importar `sonner` fuera de aquí y de `BrutalToaster`.
 */

export interface NotifyOptions {
  /** Mismo `id` = el aviso nuevo SUSTITUYE al anterior en vez de apilarse. */
  id?: string | number
  duration?: number
  /** Botón del aviso, p. ej. «Deshacer». */
  action?: { label: string; onClick: () => void }
  /** Se llama al cerrarse solo el aviso (fin de la duración). */
  onAutoClose?: () => void
  /** Se llama al cerrarlo el usuario (swipe / botón). */
  onDismiss?: () => void
}

type Show = (message: string, data?: ExternalToast) => string | number

/** Lanza el aviso; sin opciones, solo con el texto (sin un segundo argumento `undefined`). */
function show(fn: Show, message: string, options?: NotifyOptions) {
  if (!options) return fn(message)
  const { action, ...rest } = options
  return fn(
    message,
    action ? { ...rest, action: { label: action.label, onClick: () => action.onClick() } } : rest,
  )
}

export const notify = {
  success: (message: string, options?: NotifyOptions) => show(toast.success, message, options),
  error: (message: string, options?: NotifyOptions) => show(toast.error, message, options),
  info: (message: string, options?: NotifyOptions) => show(toast.info, message, options),
}
